const intNumberPrevent =  (event: KeyboardEvent): void => {
    const charCode = event.charCode;
    if (charCode < 48 || charCode > 57) {
        event.preventDefault();
    }
}

const numberPrevent = (event: KeyboardEvent): void => {
    const charCode = event.charCode;
    if (charCode < 48 || charCode > 57) {
        if (charCode!== 45 && charCode !== 46 ) {
            event.preventDefault();
        }
    }
}

export {intNumberPrevent, numberPrevent};